import { createContext } from "react";

export const AuthContext = createContext("");


export const componentDidMount = (title) =>{
    document.title = title;
    const script = document.createElement('script');
  
    script.src = "https://unpkg.com/xlsx@0.15.1/dist/xlsx.full.min.js";
    script.async = true;
  
    document.body.appendChild(script);
    
}